// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promocode-code-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: inherit;\n  text-decoration: none;\n}\n.promocode-code-link svg {\n  width: 15px;\n  height: 15px;\n  color: #6D28D9;\n  flex: 0 0 auto;\n  display: block;\n  fill: currentColor;\n  opacity: 0.75;\n}\n.promocode-code-link:hover {\n  color: #6D28D9;\n  text-decoration: none;\n}\n.promocode-code-link:hover svg {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
